import { Injectable } from '@angular/core';
import {ConfigApp, Services} from './config';
import * as $ from 'jquery';
import {AppComponent} from "./app.component";

// @ts-ignore
@Injectable({
  providedIn: 'root'
})

export let callService = function(service:any, url=null, attach =null){
  url = url ? url : service.url;
  let params = {
    url: url,
    type: service.method,
    data: service.params
  };

  if(params.data && params.data.parameters){
    // @ts-ignore
    params.contentType= "application/json";
    // @ts-ignore
    params.dataType= "json";
    // @ts-ignore
    params.cache= false;

    params.data = JSON.stringify(params.data);
  }

  if(service.headers) { // @ts-ignore
    params.headers = service.headers;
  }
  if(service.contentType) { // @ts-ignore
    params.contentType = service.contentType;
  }

  if(attach){
    // @ts-ignore
    params.contentType = false;
    // @ts-ignore
    params.processData = false;
  }

  if(ConfigApp.microServices && ConfigApp.microServices.proxy && !service.noProxy){
    params.url = ConfigApp.microServices.proxy+"?"+params.url;
  }

  return $.ajax(params)
}

export let redirectPage = function(page: any){
  return location.href = page
}

export let resetSessionVariable = function(controlSave = false){
  if(!controlSave){
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("esriJSAPIOAuth");
    sessionStorage.removeItem("esri_auth");
    sessionStorage.removeItem("infoConsole");
  }

  sessionStorage.removeItem("selectArea");
  sessionStorage.removeItem("selectCountry");
  sessionStorage.removeItem("selectParameter");
  sessionStorage.removeItem("infoAreaCountry");
}


export class DataService{
  constructor(){
  }

  isDateBefore3Days(date){
    let today = new Date();
    let threeDaysAgo = new Date();
    threeDaysAgo.setDate(today.getDate() - 3);

    return (date < threeDaysAgo);
  }

  isDateAfter3Days(date){
    let today = new Date();
    let threeDaysAfter = new Date();
    threeDaysAfter.setDate(today.getDate() + 3);

    return (date > threeDaysAfter);
  }

  getTodayData(){
    var date = new Date();
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();

    if (month < 10) { // @ts-ignore
      month = "0" + month;
    }
    if (day < 10) { // @ts-ignore
      day = "0" + day;
    }

    return year + "-" + month + "-" + day;
  }

}

